module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu is-active header--right"
  }, [(_vm.kuzcosignedin) ? _c('div', [_c('router-link', {
    staticClass: "nav-item dashboard-button",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item dashboard-button",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign out")])], 1) : _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackauth&state=2a745b37"
    }
  }, [_c('img', {
    staticClass: "signintoslack-btn",
    attrs: {
      "src": require("../assets/img/signinwithslack.svg")
    }
  })])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left header--left"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Worklogs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner container-fluid"
  }, [_c('div', {
    staticClass: "banner--content"
  }, [_c('h2', {
    staticClass: "m-b-md h2"
  }, [_vm._v("Remote time tracking made convenient.")]), _vm._v(" "), _c('h4', {
    staticClass: "m-b-lg h4"
  }, [_vm._v("Worklogs is an app that allows you to track the number of working hours for remote teams right in Slack.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,users.profile:write,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackadd&state=2a745b37"
    }
  }, [_c('img', {
    staticClass: "addtoslack-btn",
    attrs: {
      "src": require("../assets/img/addtoslack.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "intro--top"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/Art.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "intro--bottom"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Worklogs is a bullshit-free time tracking app that works with your team’s Slack HQ.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("It enables you to notify your team members when you’re available to work and what you’re working on.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "get-started"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "gs--top"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Get started in three simple steps")])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-desktop gs--bottom"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-one"
  }, [_c('div', {
    staticClass: "gs-one-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": require("../assets/img/1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-one-text"
  }, [_c('p', [_vm._v("Owner/Admin of Slack Team creates a channel dedicated for Worklogs and adds Worklogs to their Slack.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-two"
  }, [_c('div', {
    staticClass: "gs-two-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": require("../assets/img/2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-two-text"
  }, [_c('p', [_vm._v("Members of Slack Team sign in to Worklogs.co to access Dashboard.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-three"
  }, [_c('div', {
    staticClass: "gs-three-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": require("../assets/img/3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-three-text"
  }, [_c('p', [_vm._v("Members can sign in and sign out to indicate working hours.")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "features",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "features--top"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Features")])]), _vm._v(" "), _c('div', {
    staticClass: "features--middle"
  }, [_c('div', {
    staticClass: "easy-signin columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "signin-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("One Click Sign In")]), _vm._v(" "), _c('p', [_vm._v("One click sign in means you can get to work immediately. Add a reason for signing or be lazy and choose from past reasons.😎")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../assets/img/signin.gif")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "k-notification columns"
  }, [_c('div', {
    staticClass: "column right is-hidden-desktop"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Notifications")]), _vm._v(" "), _c('p', [_vm._v("Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column left"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../assets/img/notification.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column right is-hidden-mobile"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Notifications")]), _vm._v(" "), _c('p', [_vm._v("Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "activity-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Activity")]), _vm._v(" "), _c('p', [_vm._v("Detailed summary on time signed in and out with reasons and filterable date by time period.🤘🏿")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../assets/img/newactivity.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "k-notification columns"
  }, [_c('div', {
    staticClass: "column right is-hidden-desktop"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Reports")]), _vm._v(" "), _c('p', [_vm._v("Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column left"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../assets/img/newreports.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column right is-hidden-mobile"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Reports")]), _vm._v(" "), _c('p', [_vm._v("Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "activity-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("New: Slash Commands")]), _vm._v(" "), _c('p', [_vm._v("Sign in and sign out can be done right in the Slack app like this "), _c('code', [_vm._v("/worklogs sign in [with optional reason] [or sign out] [or status]")]), _vm._v(". Now, you can decide to only use the Worklogs web app when you need to see reports.🔥")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right slash"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../assets/img/slashcommands.gif")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta columns"
  }, [_c('div', {
    staticClass: "cta-button"
  }, [_c('a', {
    attrs: {
      "href": "http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackadd&state=2a745b37"
    }
  }, [_vm._v("Add Worklogs to your Slack!✌🏿")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-tablet"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Worklogs. Copyright 2017.")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "madeby"
  }, [_vm._v("Made by "), _c('a', {
    attrs: {
      "href": "https://twitter.com/olayinkaos"
    }
  }, [_vm._v("Olayinka Omole")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://twitter.com/yomieluwande"
    }
  }, [_vm._v("Yomi Eluwande")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-tablet"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "follow"
  }, [_c('a', {
    staticClass: "twitter-follow-button",
    attrs: {
      "href": "https://twitter.com/useworklogs",
      "data-size": "large"
    }
  }, [_vm._v("\n              Follow @Useworklogs")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "share"
  }, [_c('p', {
    staticClass: "m-t-xs m-r-sm"
  }, [_vm._v("Share on ")]), _vm._v(" "), _c('a', {
    staticClass: "twitter-share-button m-r-md",
    attrs: {
      "target": "_blank",
      "data-size": "large",
      "href": "https://twitter.com/intent/tweet?text=Check%20out%20Worklogs.%20A%20tool%20that%20helps%20track%20working%20hours%20for%20members%20in%20remote%20teams.&url=https://worklogs.co&via=useworklogs"
    }
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "fb-share-button",
    attrs: {
      "data-href": "https://worklogs.co",
      "data-layout": "button_count",
      "data-size": "large",
      "data-mobile-iframe": "true"
    }
  }, [_c('a', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fworklogs.co%2F&src=sdkpreparse"
    }
  }, [_vm._v("Share")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e072c9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 384
// module chunks = 1